import React, { createContext, useReducer } from "react";
import { CapabilityReducer } from "../reducers/CapabilityReducer";

export const CapabilityContext = createContext();

const CapabilityContextProvider = (props) => {
  const [capability, dispatch] = useReducer(CapabilityReducer, { data: "" });
  return (
    <CapabilityContext.Provider value={{ capability, dispatch }}>
      {props.children}
    </CapabilityContext.Provider>
  );
};

export default CapabilityContextProvider;



// WEBPACK FOOTER //
// ./src/components/overview/context/CapabilityContext.js